(() => {
  'use strict';
  const init = () => {
    const root = document.querySelector('[data-cc-pdp], [data-av-service]');
    if (!root || root.dataset.avReady) return;
    root.dataset.avReady = 'true';
    const config = JSON.parse(document.getElementById('VoltturiConfig').textContent);
    const languages = JSON.parse(document.getElementById('VoltturiTranslations').textContent);
    const core = window.VoltturiCore;
    const brandText = value => String(value || '').replace(/aurivita/gi, 'Voltturi');
    if (config.contactEmail) Object.values(languages).forEach(language => { language.text.s054 = config.contactEmail; });
    const store = (key, value, session = false) => {
      try { const storage = session ? sessionStorage : localStorage; if (value === undefined) return storage.getItem(key); storage.setItem(key, value); } catch (_) { return null; }
    };
    const remembered = store('aurivita-language-v1');
    let lang = remembered && languages[remembered] ? remembered : config.japaneseDefault ? 'ja' : (languages[config.language] ? config.language : 'ja');
    const t = (key, values = {}) => Object.entries(values).reduce((out, [k,v]) => out.replaceAll('{'+k+'}', String(v)), languages[lang].ui[key] || key);
    const money = n => core.money(n, config.currency, lang);
    const all = (selector, base = document) => Array.from(base.querySelectorAll(selector));
    const text = (selector, value, base = document) => all(selector, base).forEach(e => {e.textContent = value;});
    let statusTimer;
    const notice = message => {
      const box = document.getElementById('VoltturiStatus');
      box.textContent = message; box.hidden = false;
      clearTimeout(statusTimer); statusTimer = setTimeout(() => { box.hidden = true; }, 6500);
    };
    const localize = () => {
      document.documentElement.lang = lang;
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_COMMENT);
      while (walker.nextNode()) {
        const node = walker.currentNode, match = node.data.match(/^avt:(s\d+)$/);
        if (!match || !node.nextSibling || node.nextSibling.nodeType !== Node.TEXT_NODE) continue;
        const value = languages[lang].text[match[1]];
        if (value != null) node.nextSibling.textContent = value + (/[\s]$/.test(node.nextSibling.textContent) ? ' ' : '');
      }
      for (const attr of ['alt','aria-label','placeholder','title']) {
        all('[data-av-'+attr+']').forEach(e => e.setAttribute(attr, languages[lang].text[e.getAttribute('data-av-'+attr)]));
      }
      all('[data-av-locale-kind]').forEach(e => {
        const country = config.country === 'JP' ? t('jp') : config.country === 'US' ? t('us') : config.country === 'ES' ? t('es') : config.country+' ('+config.currency+')';
        e.querySelector('[data-av-locale-label]').textContent = e.dataset.avLocaleKind === 'country' ? country : {ja:'日本語',en:'English',es:'Español'}[lang];
      });
      all('[data-av-language]').forEach(e => {
        e.setAttribute('aria-disabled', String(!config.markets[e.dataset.avLanguage]?.enabled));
        e.setAttribute('aria-current', String(e.dataset.avLanguage === lang));
      });
    };
    const changeMarket = (language, automatic = false) => {
      const market = config.markets[language];
      if (!market?.enabled) { if (!automatic) notice(t('market')); return false; }
      if (config.country === market.country && config.language === language && config.currency === market.currency) {
        const changed = lang !== language;
        store('aurivita-language-v1', language); lang = language; localize();
        if(changed) { renderOffer(); refreshCart().catch(() => {}); }
        return true;
      }
      const guard = 'aurivita-localization-attempt-'+language;
      if (automatic && (config.editor || store(guard, undefined, true))) return false;
      store(guard, '1', true); store('aurivita-language-v1', language);
      const form = document.getElementById('VoltturiLocalization');
      form.elements.return_to.value = location.pathname + location.search;
      form.elements.country_code.value = market.country;
      form.elements.language_code.value = language;
      form.submit();
      return true;
    };
    localize();
    document.addEventListener('click', event => {
      const toggle = event.target.closest('[data-av-locale-toggle]');
      const languageButton = event.target.closest('[data-av-language]');
      if (toggle) {
        const panel = toggle.parentElement.querySelector('.disclosure__list-wrapper');
        if (!panel) return;
        const open = panel.hidden;
        all('.av-locale-control .disclosure__list-wrapper').forEach(p => p.hidden = true);
        all('[data-av-locale-toggle]').forEach(b => b.setAttribute('aria-expanded','false'));
        panel.hidden = !open; toggle.setAttribute('aria-expanded', String(open));
      } else if (languageButton) {
        changeMarket(languageButton.dataset.avLanguage);
      } else if (!event.target.closest('.av-locale-control')) {
        all('.av-locale-control .disclosure__list-wrapper').forEach(p => p.hidden = true);
        all('[data-av-locale-toggle]').forEach(b => b.setAttribute('aria-expanded','false'));
      }
    });
    document.addEventListener('shopify:section:load', event => {
      if (event.target.matches('.voltturi-footer-section') || event.target.querySelector('.cc-footer')) localize();
    });

    const cards = all('[data-cc-offer-card]', root);
    const form = root.querySelector('[data-av-product-form]');
    const subscribe = root.querySelector('[data-cc-subscribe]');
    const atc = form?.querySelector('[type="submit"]');
    const offerError = form?.querySelector('.av-offer-error');
    const state = { index: 0, subscribed: false, adding: false };
    state.subscribed = !!(config.defaultSubscribe && core.offer(config, state.index, false).subscriptionPlan);
    function showOfferError(message) { if(offerError) { offerError.textContent = message; offerError.hidden = !message; } }
    function renderOffer() {
      if (!form || !subscribe) return;
      cards.forEach((card, index) => {
        const offer = core.offer(config, index, state.subscribed);
        card.classList.toggle('is-selected', index === state.index);
        card.classList.toggle('is-highlighted', index === state.index);
        card.setAttribute('aria-pressed', String(index === state.index));
        card.setAttribute('aria-disabled', String(!offer.id || !offer.available));
        card.disabled = state.adding;
        text('[data-cc-price]', money(offer.price), card);
        text('[data-cc-compare]', offer.compare ? money(offer.compare) : '', card);
        text('[data-cc-save]', offer.saving ? t('save',{pct:offer.saving}) : '', card);
      });
      const current = core.offer(config, state.index, state.subscribed);
      subscribe.classList.toggle('is-selected', state.subscribed);
      subscribe.setAttribute('aria-pressed', String(state.subscribed));
      subscribe.disabled = state.adding;
      const planSaving = current.subscriptionPlan && current.basePrice > current.subscriptionPlan.price
        ? Math.round((current.basePrice-current.subscriptionPlan.price)/current.basePrice*100) : 0;
      text('.cc-pdp-subscribe__title', planSaving ? t('refills',{pct:planSaving}) : t('refills_plain'), subscribe);
      root.querySelectorAll('.subhide').forEach(e => e.toggleAttribute('data-cc-subhide-off', !state.subscribed));
      root.querySelector('[data-cc-terms]')?.classList.toggle('is-visible', state.subscribed);
      root.querySelectorAll('.cc-pdp-goffer__gift').forEach(e => {e.style.display=state.subscribed?'':'none';});
      const price = money(current.price);
      const atcCompare = state.subscribed && current.basePrice > current.price ? current.basePrice : config.atcComparePercent > 100 ? Math.round(current.price * config.atcComparePercent / 100) : 0;
      text('[data-av-atc-price], .cc-sticky-atc__price-current', price);
      text('[data-av-atc-compare], .cc-sticky-atc__price-compare', atcCompare ? money(atcCompare) : '');
      text('.cc-pdp-stock-line__status, .cc-sticky-atc__stock-status', current.available ? languages[lang].text.s038 : t('sold'));
      all('.cc-pdp-stock-line__body, .cc-pdp-stock-line__link, .cc-sticky-atc__stock-body, .cc-sticky-atc__stock-link').forEach(e => {e.hidden=!current.available;});
      text('.main-atc__label__text', state.adding ? t('adding') : !current.available && current.id ? t('sold') : t('add'), form);
      atc.disabled = state.adding || !current.available;
      all('[data-cc-sticky-atc-btn]').forEach(e => e.disabled = atc.disabled);
      const idInput = form.elements.namedItem('id');
      idInput.value = current.id || ''; idInput.disabled = !current.id;
      form.elements.namedItem('quantity').value = String(current.quantity || 1);
      let planInput = form.elements.namedItem('selling_plan');
      if (!planInput) { planInput = document.createElement('input'); planInput.type='hidden'; planInput.name='selling_plan'; form.append(planInput); }
      planInput.value = current.plan?.id || ''; planInput.disabled = !current.plan;
      if (!config.productId) showOfferError(t('choose'));
      root.dispatchEvent(new CustomEvent('cc-dqs:change'));
    }
    cards.forEach((card, index) => card.addEventListener('click', () => {
      if (state.adding) return;
      state.index = index; showOfferError(''); renderOffer();
      const current = core.offer(config, index, state.subscribed);
      if (current.error) showOfferError(t(current.error));
    }));
    subscribe?.addEventListener('click', () => {
      if (state.adding) return;
      if (!state.subscribed && !core.offer(config,state.index,false).subscriptionPlan) { showOfferError(t('plan_missing')); return; }
      state.subscribed = !state.subscribed; showOfferError(''); renderOffer();
    });
    renderOffer();

    // Native Shopify AJAX endpoints keep prices, discounts, selling plans and currency authoritative.
    async function api(url, body) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        const response = await fetch(url, { method: body ? 'POST' : 'GET', credentials:'same-origin', headers: body ? {'Content-Type':'application/json','Accept':'application/json'} : {'Accept':'application/json'}, body: body ? JSON.stringify(body) : undefined, signal:controller.signal });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || t('error'));
        return result;
      } finally { clearTimeout(timeout); }
    }
    const drawer = document.querySelector('cart-drawer');
    const drawerDialog = drawer.querySelector('.drawer__inner');
    const cartErrors = document.getElementById('CartDrawer-CartErrors');
    let cartBusy = false, discountBlocked = false, focusBeforeCart = null, overflowBeforeCart = '';
    const cartOpen = () => {
      if (drawer.classList.contains('active')) return;
      closeMenu();
      drawer.dataset.avOpen = 'true';
      focusBeforeCart = document.activeElement; overflowBeforeCart = document.body.style.overflow;
      document.body.style.overflow = 'hidden'; drawer.classList.add('animate');
      requestAnimationFrame(() => { drawer.classList.add('active'); drawerDialog.focus(); });
    };
    const cartClose = () => {
      if (!drawer.classList.contains('active')) return;
      drawer.dataset.avOpen = 'false';
      drawer.classList.remove('active'); document.body.style.overflow = overflowBeforeCart;
      if (focusBeforeCart?.isConnected) focusBeforeCart.focus({preventScroll:true});
    };
    function element(tag, className, value) {
      const el = document.createElement(tag); if(className) el.className=className; if(value != null) el.textContent=value; return el;
    }
    function renderCart(cart) {
      const empty = !cart.item_count;
      drawer.classList.toggle('is-empty', empty);
      drawer.querySelector('cart-drawer-items').classList.toggle('is-empty', empty);
      text('.drawer__heading', t('cart',{n:cart.item_count}),drawer);
      text('.cart-drawer__totals__row__money', core.money(cart.total_price,cart.currency || config.currency,lang),drawer);
      discountBlocked = core.discountMissing(config, cart);
      cartErrors.textContent = discountBlocked ? t('discount_missing') : '';
      const checkout = document.getElementById('CartDrawer-Checkout'); checkout.disabled = empty || cartBusy || discountBlocked;
      if(!empty && !document.querySelector('#cart-icon-bubble .cart-count-bubble')) {
        const bubble=element('div','cart-count-bubble'),value=element('span');value.setAttribute('aria-hidden','true');bubble.append(value);document.getElementById('cart-icon-bubble')?.append(bubble);
      }
      all('.cart-count-bubble').forEach(b => {
        b.hidden = empty;
        const span = b.querySelector('span[aria-hidden]') || b.querySelector('span'); if (span) span.textContent=cart.item_count;
      });
      const container = document.getElementById('CartDrawer-CartItems'); container.replaceChildren();
      for (const item of cart.items) {
        const row = element('div','av-cart-item'); row.dataset.key = item.key;
        const brandedItem = String(item.product_id) === String(config.productId) || config.offers.some(offer => String(offer.id) === String(item.variant_id || item.id));
        const itemImage = brandedItem ? config.brandProductImage : item.image;
        if (itemImage) {const img=element('img');img.src=itemImage;img.alt=brandText(item.product_title);img.width=80;row.append(img);}
        else row.append(element('div'));
        const details = element('div');
        const link = element('a','av-cart-item__name',brandText(item.product_title));link.href=item.url || '#aurivita-offer';details.append(link);
        if(item.variant_title && item.variant_title !== 'Default Title') details.append(element('span','av-cart-item__variant',brandText(item.variant_title)));
        if(item.selling_plan_allocation) details.append(element('span','av-cart-item__plan',brandText(item.selling_plan_allocation.selling_plan.name)));
        const bottom = element('div','av-cart-item__bottom'), quantity=element('div','av-cart-quantity');
        for (const delta of [-1,1]) {
          if(delta === 1) {
            const input=element('input');input.type='number';input.min='0';input.step='1';input.value=item.quantity;input.setAttribute('aria-label',t('quantity'));
            input.addEventListener('change',()=> {const n=Number(input.value);if(Number.isInteger(n)&&n>=0) changeItem(item.key,n);else input.value=item.quantity;});quantity.append(input);
          }
          const button=element('button','',delta<0?'−':'+');button.type='button';button.setAttribute('aria-label',t('quantity')+(delta<0?' −':' +'));button.addEventListener('click',()=>changeItem(item.key,Math.max(0,item.quantity+delta)));quantity.append(button);
        }
        bottom.append(quantity,element('span','av-cart-item__price',core.money(item.final_line_price,cart.currency||config.currency,lang)));
        const remove=element('button','av-cart-remove',t('remove'));remove.type='button';remove.addEventListener('click',()=>changeItem(item.key,0));
        details.append(bottom,remove);row.append(details);container.append(row);
      }
    }
    async function refreshCart() { const cart=await api(config.routes.cart);renderCart(cart);return cart; }
    async function changeItem(id, quantity) {
      if(cartBusy) return; cartBusy=true;cartErrors.textContent='';
      all('button,input',drawer).forEach(e=>e.disabled=true);
      try {const cart=await api(config.routes.change,{id,quantity});cartBusy=false;renderCart(cart);}
      catch(error) {cartErrors.textContent=error.name==='AbortError'?t('error'):error.message;}
      finally {cartBusy=false;all('button,input',drawer).forEach(e=>e.disabled=false);document.getElementById('CartDrawer-Checkout').disabled=drawer.classList.contains('is-empty') || discountBlocked;}
    }
    form?.addEventListener('submit', async event => {
      event.preventDefault(); if(state.adding || cartBusy) return;
      showOfferError('');let data;
      try {data=core.payload(config,state.index,state.subscribed);}catch(error){showOfferError(t(error.message));return;}
      state.adding=true;renderOffer();
      try {
        await api(config.routes.add,data);
        try {await refreshCart();cartOpen();} catch (_) {window.location.assign(config.routes.cart.replace(/\.js$/,''));}
      } catch(error) {showOfferError(error.name==='AbortError'?t('error'):error.message);}
      finally {state.adding=false;renderOffer();}
    });
    all('[data-av-open-cart], #cart-icon-bubble').forEach(e=>e.addEventListener('click',async event=>{
      event.preventDefault();try{await refreshCart();cartOpen();}catch(error){notice(t('error'));}
    }));
    all('.drawer__close, #CartDrawer-Overlay',drawer).forEach(e=>e.addEventListener('click',cartClose));
    drawer.addEventListener('keydown',event=>{
      if(event.key==='Escape')cartClose();
      if(event.key!=='Tab')return;
      const focusable=all('button:not([disabled]), a[href], input:not([disabled])',drawer).filter(e=>e.getClientRects().length);
      const first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey && (document.activeElement===first || document.activeElement===drawerDialog)){event.preventDefault();last?.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
    });
    // The saved header uses details elements; restore its open/close behavior without source-store JS.
    const menu=document.getElementById('Details-menu-drawer-container');
    let menuOverflow='';
    function closeMenu(){if(!menu?.open)return;menu.open=false;menu.classList.remove('menu-opening');menu.querySelector('summary').setAttribute('aria-expanded','false');document.body.style.overflow=menuOverflow;}
    if(menu){
      menu.addEventListener('toggle',()=>{
        const summary=menu.querySelector('summary');summary.setAttribute('aria-expanded',String(menu.open));
        if(menu.open){menuOverflow=document.body.style.overflow;document.body.style.overflow='hidden';requestAnimationFrame(()=>menu.classList.add('menu-opening'));}
        else{menu.classList.remove('menu-opening');if(drawer.dataset.avOpen!=='true')document.body.style.overflow=menuOverflow;}
      });
      all('.menu-drawer__close-menu-btn',menu).forEach(e=>e.addEventListener('click',closeMenu));
      all('a',menu).forEach(e=>e.addEventListener('click',closeMenu));
    }
    all('details-modal').forEach(modal=>{
      const details=modal.querySelector('details');
      modal.querySelector('summary')?.addEventListener('click',()=>requestAnimationFrame(()=>{if(details.open)modal.querySelector('input[type="search"]')?.focus();}));
      all('.modal__close-button',modal).forEach(e=>e.addEventListener('click',()=>{details.open=false;}));
    });
    document.addEventListener('keydown',event=>{
      if(event.key!=='Escape')return;closeMenu();
      all('.av-locale-control .disclosure__list-wrapper').forEach(e=>e.hidden=true);
      all('[data-av-locale-toggle]').forEach(e=>e.setAttribute('aria-expanded','false'));
      all('details-modal details').forEach(e=>e.open=false);
    });
    const sticky=document.querySelector('[data-cc-sticky-atc]');
    if(sticky){
      sticky.classList.remove('is-visible');sticky.setAttribute('aria-hidden','true');
      const updateSticky=()=>{const visible=atc.getBoundingClientRect().bottom<0;sticky.classList.toggle('is-visible',visible);sticky.setAttribute('aria-hidden',String(!visible));};
      let frame=0;window.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;updateSticky();});},{passive:true});
      window.addEventListener('resize',updateSticky);updateSticky();
      all('[data-cc-sticky-atc-btn]',sticky).forEach(e=>e.addEventListener('click',()=>form.requestSubmit(atc)));
    }
    // Honor source in-page actions while retaining native research and information links.
    all('a[href="#aurivita-offer"]').forEach(e=>e.addEventListener('click',event=>{
      if(e.closest('.cc-pdp-inline-perks') && !e.classList.contains('subhide')) {
        event.preventDefault();root.querySelector('.cc-pdp-guarantee, .cc-guarantee')?.scrollIntoView({behavior:'smooth',block:'center'});
      } else if(e.classList.contains('subhide')) {
        event.preventDefault();window.location.assign(document.querySelector('a[data-av-subscription-link]')?.href || '/account');
      }
    }));
    refreshCart().catch(() => {});
    if(config.japaneseDefault && !remembered) changeMarket('ja',true);
    else if(remembered && languages[remembered]) changeMarket(remembered,true);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',event=>{if(event.target.querySelector('[data-cc-pdp], [data-av-service]'))window.location.reload();});
})();
